import { FoundationsFormType } from '../Types/FoundationsTypes'

export function FoundationsForm(props: FoundationsFormType) {
    return (
        <form
            id={props.id}
            onSubmit={
                props.handleSubmit ? props.handleSubmit(props.submitFunction) : props.submitFunction
            }
        >
            {props.children}
        </form>
    )
}
